// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3eJkD","options":"AnswerScale_options__3MRye","selected":"AnswerScale_selected__1IqRd"};